/* ============================================================
   VECTOR — Theme JavaScript v7
   ============================================================ */

document.addEventListener('DOMContentLoaded', function () {

  // ── Cart Drawer ──────────────────────────────────────────
  const cartDrawer = document.getElementById('cart-drawer');
  const cartBtns = document.querySelectorAll('[data-cart-toggle]');
  const cartClose = document.querySelector('.cart-drawer__close');
  const cartOverlay = document.querySelector('.cart-drawer__overlay');

  function renderCart() {
    const body = document.getElementById('cart-drawer-body');
    if (!body) return;
    body.innerHTML = `<div style="padding:1rem;display:flex;flex-direction:column;gap:12px;">
      ${[1,2,3].map(()=>`<div class="skeleton" style="height:72px;border-radius:10px;"></div>`).join('')}
    </div>`;

    fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {
        const countEl = document.querySelector('.cart-count');
        if (countEl) {
          countEl.textContent = cart.item_count;
          countEl.style.display = cart.item_count > 0 ? 'flex' : 'none';
        }

        if (!cart.items || cart.items.length === 0) {
          body.innerHTML = `<div style="text-align:center;padding:48px 20px;">
            <div style="font-size:48px;margin-bottom:16px;">🛒</div>
            <p style="font-weight:700;font-size:1rem;margin-bottom:8px;">Votre panier est vide</p>
            <p style="font-size:14px;color:#999;">Ajoutez des produits pour commencer</p>
          </div>`;
          return;
        }

        const subtotal = (cart.total_price / 100).toFixed(2).replace('.', ',');
        let html = '<ul class="cart-drawer__items" style="margin:0;padding:0;list-style:none;">';
        cart.items.forEach(item => {
          const price = (item.final_line_price / 100).toFixed(2).replace('.', ',');
          const img = item.image
            ? `<img src="${item.image}" alt="${item.title}" style="width:64px;height:64px;object-fit:cover;border-radius:10px;flex-shrink:0;">`
            : `<div style="width:64px;height:64px;background:#f0f0f0;border-radius:10px;flex-shrink:0;"></div>`;
          html += `
            <li style="display:flex;gap:14px;padding:14px 0;border-bottom:1px solid #f0f0f0;align-items:center;">
              ${img}
              <div style="flex:1;min-width:0;">
                <p style="margin:0;font-weight:700;font-size:.85rem;line-height:1.3;margin-bottom:3px;">${item.product_title}</p>
                ${item.variant_title && item.variant_title !== 'Default Title'
                  ? `<span class="drawer-flavor-pill" data-flavor="${item.variant_title}" style="display:inline-flex;align-items:center;gap:4px;font-size:.75rem;font-weight:600;padding:2px 9px;border-radius:20px;margin-bottom:5px;background:#f0f0f0;color:#666;border:1px solid #e0e0e0;"><span class="drawer-flavor-dot" style="width:7px;height:7px;border-radius:50%;background:#bbb;flex-shrink:0;"></span>${item.variant_title}</span>`
                  : ''}
                <div style="display:flex;align-items:center;gap:8px;margin-top:6px;">
                  <button data-change-qty="${item.key}" data-delta="-1" style="width:26px;height:26px;border:1px solid #e0e0e0;background:#fff;cursor:pointer;border-radius:6px;font-size:1rem;line-height:1;font-weight:700;display:flex;align-items:center;justify-content:center;">−</button>
                  <span style="font-size:.9rem;font-weight:700;min-width:20px;text-align:center;">${item.quantity}</span>
                  <button data-change-qty="${item.key}" data-delta="1" style="width:26px;height:26px;border:1px solid #e0e0e0;background:#fff;cursor:pointer;border-radius:6px;font-size:1rem;line-height:1;font-weight:700;display:flex;align-items:center;justify-content:center;">+</button>
                </div>
              </div>
              <div style="text-align:right;flex-shrink:0;">
                <p style="margin:0;font-weight:800;font-size:.95rem;">${price}\u00a0€</p>
                <button data-remove-item="${item.key}" style="background:none;border:none;color:#bbb;font-size:.72rem;cursor:pointer;margin-top:6px;text-decoration:underline;">Retirer</button>
              </div>
            </li>`;
        });
        html += '</ul>';
        html += `<div style="padding:16px 0 8px;font-weight:800;font-size:1rem;display:flex;justify-content:space-between;border-top:2px solid #000;margin-top:8px;">
          <span>Sous-total</span><span>${subtotal}\u00a0€</span>
        </div>`;
        body.innerHTML = html;

        // Coloriser les pills de goût dans le drawer
        (function applyFlavorColors() {
          var fc = {
            'chocolat':'#c8956c','chocolate':'#c8956c','choconoisette':'#b8804c','chocolatnoisette':'#b8804c',
            'noisette':'#c8a86a','hazelnut':'#c8a86a','cookie':'#d4b896','biscuit':'#d4b896',
            'caramel':'#e8b870','saltedcaramel':'#e8b870','caramelsale':'#e8b870',
            'vanille':'#e0c930','vanilla':'#e0c930','pistache':'#b8d888','pistachio':'#b8d888',
            'fraise':'#f7b8c4','strawberry':'#f7b8c4','framboise':'#f090b8','raspberry':'#f090b8',
            'cerise':'#e87090','cherry':'#e87090','fruitsrouges':'#e88098','berries':'#e88098',
            'citron':'#e8dc50','lemon':'#e8dc50','citronvert':'#b8e870','lime':'#b8e870',
            'peche':'#ffc8a0','peach':'#ffc8a0','pechemaracuja':'#ffc8a0','pecheframboise':'#f7a8b8',
            'mangue':'#ffc87a','mango':'#ffc87a','mangopassion':'#ffb860',
            'ananas':'#f8e060','pineapple':'#f8e060','pasteque':'#88e0a0','watermelon':'#88e0a0',
            'coco':'#d8c8b8','coconut':'#d8c8b8','myrtille':'#a0b8f0','blueberry':'#a0b8f0',
            'menthe':'#98e8c8','mint':'#98e8c8','cafe':'#c8a888','coffee':'#c8a888',
            'cola':'#c88878','punch':'#e87878','tropical':'#f9d860','exotique':'#f9d860',
            'pomme':'#a8d870','apple':'#a8d870','pommeverte':'#90d050',
            'cassis':'#c090e0','blackcurrant':'#c090e0','pommecassis':'#c088c8',
            'manguecoco':'#f0c070','manguenoixdecoco':'#f0c070',
            'mandarine':'#ff9a40','orange':'#ff9a40','neutre':'#c8d0d8','nature':'#c8d0d8'
          };
          function norm(s) {
            return s.toLowerCase()
              .replace(/[éèêë]/g,'e').replace(/[àâä]/g,'a').replace(/[ùûü]/g,'u')
              .replace(/[îï]/g,'i').replace(/[ôö]/g,'o').replace(/[ç]/g,'c')
              .replace(/[\s\-_''()]/g,'');
          }
          function hexToRgb(hex) {
            var r=parseInt(hex.slice(1,3),16),g=parseInt(hex.slice(3,5),16),b=parseInt(hex.slice(5,7),16);
            return {r,g,b};
          }
          function darken(hex) {
            var c=hexToRgb(hex);
            return 'rgb('+Math.max(0,c.r-60)+','+Math.max(0,c.g-60)+','+Math.max(0,c.b-60)+')';
          }
          body.querySelectorAll('.drawer-flavor-pill').forEach(function(pill) {
            var raw = pill.dataset.flavor || '';
            var slug = norm(raw);
            var color = fc[slug];
            if (!color) {
              raw.toLowerCase().split(/[\s\-_]+/).forEach(function(w) {
                if (!color && fc[norm(w)]) color = fc[norm(w)];
              });
            }
            if (color) {
              var c = hexToRgb(color);
              pill.style.background = 'rgba('+c.r+','+c.g+','+c.b+',0.18)';
              pill.style.color = darken(color);
              pill.style.borderColor = 'rgba('+c.r+','+c.g+','+c.b+',0.5)';
              var dot = pill.querySelector('.drawer-flavor-dot');
              if (dot) dot.style.background = color;
            }
          });
        })();

        body.querySelectorAll('[data-change-qty]').forEach(btn => {
          btn.addEventListener('click', function() {
            const key = this.dataset.changeQty;
            const delta = parseInt(this.dataset.delta);
            const currentItem = cart.items.find(i => i.key === key);
            if (!currentItem) return;
            const newQty = currentItem.quantity + delta;
            fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: key, quantity: Math.max(0, newQty) })
            }).then(() => renderCart());
          });
        });

        body.querySelectorAll('[data-remove-item]').forEach(btn => {
          btn.addEventListener('click', function() {
            fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: this.dataset.removeItem, quantity: 0 })
            }).then(() => renderCart());
          });
        });
      })
      .catch(() => {
        if (body) body.innerHTML = '<p style="padding:1rem;color:#888">Erreur de chargement.</p>';
      });
  }

  function openCart() {
    if (cartDrawer) cartDrawer.classList.add('open');
    document.body.style.overflow = 'hidden';
    renderCart();
    fetch('/cart.js').then(r=>r.json()).then(c=>updateShipBar(c));
  }

  function closeCart() {
    if (cartDrawer) cartDrawer.classList.remove('open');
    document.body.style.overflow = '';
  }

  // ── Barre livraison ──────────────────────────────────────
  function updateShipBar(cart) {
    const bar  = document.getElementById('cart-ship-progress');
    const txt  = document.getElementById('cart-ship-text');
    const fill = document.getElementById('cart-ship-fill');
    if (!bar) return;
    if (!cart || cart.item_count === 0) { bar.style.display = 'none'; return; }
    const THRESHOLD = 6000;
    const pct = Math.min(Math.round(cart.total_price / THRESHOLD * 100), 100);
    const remain = THRESHOLD - cart.total_price;
    fill.style.width = pct + '%';
    if (remain > 0) {
      const euros = (remain / 100).toFixed(2).replace('.', ',');
      txt.innerHTML = '\uD83D\uDE9A Plus que <strong>' + euros + '\u00a0€</strong> pour la livraison offerte !';
    } else {
      txt.innerHTML = '\uD83C\uDF89 <strong>Livraison offerte !</strong>';
      fill.style.background = '#16a34a';
    }
    bar.style.display = 'block';
  }

  const drawerCheckout = document.getElementById('drawer-checkout');
  if (drawerCheckout) {
    drawerCheckout.addEventListener('click', function(e) {
      e.preventDefault();
      document.body.style.overflow = '';
      if (cartDrawer) cartDrawer.classList.remove('open');
      window.location.href = '/checkout';
    });
  }

  cartBtns.forEach(btn => btn.addEventListener('click', openCart));
  if (cartClose) cartClose.addEventListener('click', closeCart);
  if (cartOverlay) cartOverlay.addEventListener('click', closeCart);

  // ── Mobile Menu ──────────────────────────────────────────
  const mobileToggle = document.querySelector('.mobile-menu-toggle');
  const mobileMenu = document.getElementById('mobile-menu');
  const mobileClose = document.querySelector('.mobile-menu__close button');
  const mobileOverlay = document.querySelector('.mobile-menu__overlay');

  if (mobileToggle && mobileMenu) {
    mobileToggle.addEventListener('click', function () {
      mobileMenu.classList.add('open');
      document.body.style.overflow = 'hidden';
    });
  }
  function closeMobileMenu() {
    if (mobileMenu) mobileMenu.classList.remove('open');
    document.body.style.overflow = '';
  }
  if (mobileClose) mobileClose.addEventListener('click', closeMobileMenu);
  if (mobileOverlay) mobileOverlay.addEventListener('click', closeMobileMenu);

  // ── Product Tabs ─────────────────────────────────────────
  document.querySelectorAll('.product-tabs__btn').forEach(btn => {
    btn.addEventListener('click', function () {
      const target = this.dataset.tab;
      document.querySelectorAll('.product-tabs__btn').forEach(b => b.classList.remove('active'));
      document.querySelectorAll('.product-tabs__panel').forEach(p => p.classList.remove('active'));
      this.classList.add('active');
      const panel = document.getElementById('tab-' + target);
      if (panel) panel.classList.add('active');
    });
  });

  // ── FAQ Accordion ────────────────────────────────────────
  document.querySelectorAll('.faq-item').forEach(item => {
    const question = item.querySelector('.faq-item__question');
    if (question) {
      question.addEventListener('click', function () {
        const isOpen = item.classList.contains('open');
        document.querySelectorAll('.faq-item').forEach(i => i.classList.remove('open'));
        if (!isOpen) item.classList.add('open');
      });
    }
  });

  // ── Product Gallery avec crossfade ───────────────────────
  const thumbs = document.querySelectorAll('.product-gallery__thumb');
  const mainImg = document.querySelector('.product-gallery__main img');

  thumbs.forEach(thumb => {
    thumb.addEventListener('click', function () {
      thumbs.forEach(t => t.classList.remove('active'));
      this.classList.add('active');
      if (mainImg) {
        const thumbImg = this.querySelector('img');
        const src = thumbImg?.dataset.src || thumbImg?.src;
        if (src) {
          // Crossfade smooth
          mainImg.classList.add('fading');
          setTimeout(() => {
            mainImg.src = src;
            mainImg.classList.remove('fading');
          }, 200);
        }
      }
    });
  });

  // ── Quantity Selector ────────────────────────────────────
  document.querySelectorAll('.product-quantity').forEach(wrap => {
    const input = wrap.querySelector('input');
    const minus = wrap.querySelector('[data-qty="minus"]');
    const plus  = wrap.querySelector('[data-qty="plus"]');
    if (minus && input) minus.addEventListener('click', () => { const v = parseInt(input.value) || 1; if (v > 1) input.value = v - 1; });
    if (plus  && input) plus.addEventListener('click',  () => { const v = parseInt(input.value) || 1; input.value = v + 1; });
  });

  // ── Option Buttons + Variant Matching ───────────────────
  function getSelectedOptions() {
    const selected = {};
    document.querySelectorAll('.product-option__values').forEach(group => {
      const activeBtn = group.querySelector('.option-btn.selected');
      if (activeBtn) selected[activeBtn.dataset.option] = activeBtn.dataset.value;
    });
    return selected;
  }

  // Adapte une URL image Shopify CDN pour une taille précise
  function shopifyImgUrl(src, size) {
    if (!src) return src;
    return src
      .replace(/_(pico|icon|thumb|small|compact|medium|large|grande|\d+x\d*|\d*x\d+)(\.[^.?]+)(\?|$)/, '$2$3')
      .replace(/(\.[^.?]+)(\?|$)/, '_' + size + '$1$2');
  }

  function imgBase(src) {
    return (src || '').split('?')[0]
      .replace(/_(pico|icon|thumb|small|compact|medium|large|grande|\d+x\d*|\d*x\d+)(\.[^.?]+)$/, '$2');
  }

  function updateVariantFromOptions() {
    const variants = window.__vectorVariants;
    if (!variants) return;
    const selected = getSelectedOptions();
    const positions = Object.keys(selected).map(Number).sort();
    const match = variants.find(v => positions.every(pos => v['option' + pos] === selected[pos]));
    const atcBtn = document.querySelector('[data-add-to-cart]');
    if (!atcBtn) return;
    if (match) {
      atcBtn.dataset.variantId = match.id;
      atcBtn.disabled = !match.available;
      atcBtn.textContent = match.available ? atcBtn.dataset.originalText || atcBtn.textContent : 'Indisponible';
      const priceEl = document.getElementById('product-price');
      const formatted = (match.price / 100).toFixed(2).replace('.', ',') + '\u00a0\u20ac';
      if (priceEl) priceEl.textContent = formatted;

      // Sync sélecteur caché
      const variantSel = document.getElementById('variant-selector');
      if (variantSel) variantSel.value = match.id;

      // Sticky ATC price sync
      const stickyPrice = document.getElementById('sticky-atc-price');
      if (stickyPrice) stickyPrice.textContent = formatted;

      // Changement d'image selon variante
      if (match.featured_image && match.featured_image.src) {
        const mainImgEl = document.querySelector('.product-gallery__main img');
        if (mainImgEl) {
          const hiRes = shopifyImgUrl(match.featured_image.src, '800x800');
          mainImgEl.classList.add('fading');
          setTimeout(() => {
            mainImgEl.src = hiRes;
            mainImgEl.classList.remove('fading');
          }, 200);
        }
        const vBase = imgBase(match.featured_image.src);
        document.querySelectorAll('.product-gallery__thumb').forEach(thumb => {
          const tImg = thumb.querySelector('img');
          if (!tImg) return;
          const tBase = imgBase(tImg.dataset.src || tImg.src);
          if (tBase === vBase) {
            document.querySelectorAll('.product-gallery__thumb').forEach(t => t.classList.remove('active'));
            thumb.classList.add('active');
          }
        });
      }

      // Mise à jour affichage option sélectionnée
      document.querySelectorAll('.product-option').forEach(optWrap => {
        const selectedLabel = optWrap.querySelector('.product-option__selected');
        const activeBtn = optWrap.querySelector('.option-btn.selected');
        if (selectedLabel && activeBtn) selectedLabel.textContent = ': ' + activeBtn.dataset.value;
      });
    }
  }

  document.querySelectorAll('.product-option__values').forEach(group => {
    group.querySelectorAll('.option-btn').forEach(btn => {
      btn.addEventListener('click', function () {
        group.querySelectorAll('.option-btn').forEach(b => b.classList.remove('selected'));
        this.classList.add('selected');
        updateVariantFromOptions();
      });
    });
  });

  // ── Products Tabs Filter ─────────────────────────────────
  const filterTabs = document.querySelectorAll('.products-tab');
  const productCards = document.querySelectorAll('.product-card[data-category]');
  filterTabs.forEach(tab => {
    tab.addEventListener('click', function () {
      filterTabs.forEach(t => t.classList.remove('active'));
      this.classList.add('active');
      const cat = this.dataset.filter;
      productCards.forEach(card => {
        card.style.display = (cat === 'all' || card.dataset.category === cat) ? '' : 'none';
      });
    });
  });

  // ── Scroll Reveal avec stagger ───────────────────────────
  const reveals = document.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });
    reveals.forEach(el => observer.observe(el));
  } else {
    reveals.forEach(el => el.classList.add('visible'));
  }

  // ── Add to Cart (AJAX) ───────────────────────────────────
  document.querySelectorAll('[data-add-to-cart]').forEach(btn => {
    if (!btn.dataset.originalText) btn.dataset.originalText = btn.textContent;
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      const variantId = this.dataset.variantId;
      const qty = document.getElementById('pack-hidden-qty')?.value
        || document.querySelector('.product-quantity input')?.value
        || 1;

      if (!variantId) { alert('Veuillez sélectionner une option.'); return; }

      const originalText = this.dataset.originalText;
      this.textContent = '⏳ Ajout en cours…';
      this.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: parseInt(qty) })
      })
      .then(res => {
        if (!res.ok) return res.json().then(e => { throw new Error(e.description || 'Erreur ajout panier'); });
        return res.json();
      })
      .then(() => {
        this.textContent = '✓ Ajouté !';
        this.style.background = '#16a34a';
        setTimeout(() => {
          this.textContent = originalText;
          this.disabled = false;
          this.style.background = '';
        }, 2000);
        openCart();
      })
      .catch(err => {
        this.textContent = originalText;
        this.disabled = false;
        alert('Erreur : ' + (err.message || 'impossible d\'ajouter au panier.'));
      });
    });
  });

  // ── Sticky ATC (product page, mobile) ───────────────────
  const stickyAtc = document.getElementById('sticky-atc');
  const stickyBtn = document.getElementById('sticky-atc-btn');
  const mainAtcBtn = document.querySelector('[data-add-to-cart]');
  const productInfoEl = document.querySelector('.product-info__price');

  if (stickyAtc && mainAtcBtn) {
    const stickyObs = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        stickyAtc.classList.toggle('visible', !entry.isIntersecting);
      });
    }, { threshold: 0, rootMargin: '-80px 0px 0px 0px' });
    if (productInfoEl) stickyObs.observe(productInfoEl);

    if (stickyBtn) {
      stickyBtn.addEventListener('click', function() {
        // Délègue au bouton principal
        if (mainAtcBtn && !mainAtcBtn.disabled) mainAtcBtn.click();
      });
    }
  }

  // ── Update Cart Count ────────────────────────────────────
  function updateCartCount() {
    fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {
        const countEl = document.querySelector('.cart-count');
        if (countEl) {
          countEl.textContent = cart.item_count;
          countEl.style.display = cart.item_count > 0 ? 'flex' : 'none';
        }
      });
  }
  updateCartCount();

  // ── Newsletter Form ──────────────────────────────────────
  const newsletterForm = document.querySelector('.newsletter-form');
  if (newsletterForm) {
    newsletterForm.addEventListener('submit', function (e) {
      e.preventDefault();
      const email = this.querySelector('input[type="email"]')?.value;
      if (email) {
        this.innerHTML = '<p style="font-weight:800;font-size:1.1rem;color:var(--color-black)">✓ Merci ! Vous\u00eates inscrit(e). Surveillez votre boîte mail.</p>';
      }
    });
  }

  // ── Sticky Header Shadow ─────────────────────────────────
  const header = document.querySelector('.site-header');
  window.addEventListener('scroll', function () {
    if (header) header.classList.toggle('scrolled', window.scrollY > 20);
  }, { passive: true });

  // ── Back to Top ──────────────────────────────────────────
  const backToTop = document.getElementById('back-to-top');
  if (backToTop) {
    window.addEventListener('scroll', () => {
      backToTop.classList.toggle('visible', window.scrollY > 400);
    }, { passive: true });
    backToTop.addEventListener('click', () => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }

  // ── Wishlist (localStorage) ──────────────────────────────
  const WISHLIST_KEY = 'vn_wishlist';

  function getWishlist() {
    try { return JSON.parse(localStorage.getItem(WISHLIST_KEY) || '[]'); }
    catch(e) { return []; }
  }

  function saveWishlist(list) {
    try { localStorage.setItem(WISHLIST_KEY, JSON.stringify(list)); } catch(e) {}
  }

  function isWishlisted(productId) {
    return getWishlist().includes(String(productId));
  }

  function toggleWishlist(productId) {
    productId = String(productId);
    let list = getWishlist();
    if (list.includes(productId)) {
      list = list.filter(id => id !== productId);
    } else {
      list.push(productId);
    }
    saveWishlist(list);
    return list.includes(productId);
  }

  function initWishlistButtons() {
    document.querySelectorAll('.product-card__wishlist[data-product-id]').forEach(function(btn) {
      const pid = btn.dataset.productId;
      if (isWishlisted(pid)) btn.classList.add('active');

      btn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        const added = toggleWishlist(pid);
        btn.classList.toggle('active', added);
        btn.textContent = added ? '♥' : '♡';

        // Mini toast feedback
        const toast = document.createElement('div');
        toast.className = 'wishlist-toast';
        toast.textContent = added ? '♥ Ajouté aux favoris' : '♡ Retiré des favoris';
        document.body.appendChild(toast);
        requestAnimationFrame(() => toast.classList.add('visible'));
        setTimeout(() => { toast.classList.remove('visible'); setTimeout(() => toast.remove(), 300); }, 1800);
      });
    });
  }

  initWishlistButtons();

  // ── Search Overlay ───────────────────────────────────────
  const searchOverlay = document.getElementById('search-overlay');
  const searchToggle  = document.getElementById('search-toggle');
  const searchClose   = document.getElementById('search-close');
  const searchInput   = document.getElementById('search-input');
  const searchResults = document.getElementById('search-results');
  const searchClear   = document.getElementById('search-clear');

  function openSearch() {
    if (!searchOverlay) return;
    searchOverlay.hidden = false;
    searchOverlay.removeAttribute('hidden');
    requestAnimationFrame(() => searchOverlay.classList.add('open'));
    document.body.style.overflow = 'hidden';
    if (searchToggle) searchToggle.setAttribute('aria-expanded', 'true');
    setTimeout(() => { if (searchInput) searchInput.focus(); }, 250);
  }

  function closeSearch() {
    if (!searchOverlay) return;
    searchOverlay.classList.remove('open');
    document.body.style.overflow = '';
    if (searchToggle) searchToggle.setAttribute('aria-expanded', 'false');
    setTimeout(() => { searchOverlay.hidden = true; }, 200);
    if (searchInput) searchInput.value = '';
    if (searchClear) searchClear.hidden = true;
    resetSearchResults();
  }

  function resetSearchResults() {
    if (!searchResults) return;
    searchResults.innerHTML = `
      <div class="search-overlay__suggestions">
        <p class="search-overlay__hint">Suggestions rapides</p>
        <div class="search-overlay__tags">
          <a href="/search?type=product&q=whey" class="search-tag">Whey</a>
          <a href="/search?type=product&q=creatine" class="search-tag">Créatine</a>
          <a href="/search?type=product&q=bcaa" class="search-tag">BCAA</a>
          <a href="/search?type=product&q=electrolytes" class="search-tag">Électrolytes</a>
          <a href="/search?type=product&q=booster" class="search-tag">Booster</a>
        </div>
      </div>`;
  }

  let searchTimer = null;

  function doSearch(query) {
    query = query.trim();
    if (!query || query.length < 2) { resetSearchResults(); return; }

    searchResults.innerHTML = '<div class="search-overlay__loading">Recherche en cours…</div>';

    clearTimeout(searchTimer);
    searchTimer = setTimeout(function() {
      fetch('/search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=product&resources[limit]=6')
        .then(function(res) { return res.json(); })
        .then(function(data) {
          const products = (data.resources && data.resources.results && data.resources.results.products) || [];
          if (products.length === 0) {
            searchResults.innerHTML = `
              <div class="search-overlay__no-result">
                <strong>Aucun résultat pour "${query}"</strong>
                <span>Essayez un autre terme ou explorez nos collections.</span>
              </div>
              <a href="/search?type=product&q=${encodeURIComponent(query)}" class="search-overlay__all-link">Voir tous les résultats →</a>`;
            return;
          }
          let html = '<div class="search-results__grid">';
          products.forEach(function(p) {
            const price = p.price ? (parseFloat(p.price) / 100).toFixed(2).replace('.', ',') + '\u00a0€' : '';
            const img = p.image ? `<img class="search-result-item__img" src="${p.image}" alt="${p.title}" loading="lazy">` : '<div class="search-result-item__img"></div>';
            html += `
              <a href="${p.url}" class="search-result-item">
                ${img}
                <div class="search-result-item__info">
                  <div class="search-result-item__title">${p.title}</div>
                  ${price ? `<div class="search-result-item__price">${price}</div>` : ''}
                </div>
              </a>`;
          });
          html += '</div>';
          html += `<a href="/search?type=product&q=${encodeURIComponent(query)}" class="search-overlay__all-link">Voir tous les résultats →</a>`;
          searchResults.innerHTML = html;
        })
        .catch(function() {
          searchResults.innerHTML = '<div class="search-overlay__no-result"><strong>Erreur de recherche</strong><span>Veuillez réessayer.</span></div>';
        });
    }, 280);
  }

  if (searchToggle) searchToggle.addEventListener('click', openSearch);
  if (searchClose)  searchClose.addEventListener('click', closeSearch);

  if (searchOverlay) {
    const backdrop = searchOverlay.querySelector('.search-overlay__backdrop');
    if (backdrop) backdrop.addEventListener('click', closeSearch);
  }

  if (searchInput) {
    searchInput.addEventListener('input', function() {
      const val = this.value;
      if (searchClear) searchClear.hidden = val.length === 0;
      doSearch(val);
    });
    searchInput.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') closeSearch();
    });
  }

  if (searchClear) {
    searchClear.addEventListener('click', function() {
      if (searchInput) { searchInput.value = ''; searchInput.focus(); }
      this.hidden = true;
      resetSearchResults();
    });
  }

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && searchOverlay && searchOverlay.classList.contains('open')) closeSearch();
  });

});

// ── Wishlist toast CSS (injecté une seule fois) ──────────
(function() {
  var s = document.createElement('style');
  s.textContent = '.wishlist-toast{position:fixed;bottom:24px;left:50%;transform:translateX(-50%) translateY(20px);background:var(--color-text,#000);color:var(--color-bg,#fff);padding:10px 20px;border-radius:99px;font-size:14px;font-weight:600;opacity:0;transition:opacity .25s,transform .25s;z-index:10000;pointer-events:none}.wishlist-toast.visible{opacity:1;transform:translateX(-50%) translateY(0)}.product-card__wishlist.active{color:#e11d48}.product-card__wishlist{transition:color .2s,transform .2s}.product-card__wishlist:hover{transform:scale(1.2)}';
  document.head.appendChild(s);
})();
